import pluginConfig from './config'
import Cookie from 'js-cookie'

/**
 * Console log depending on config debug mode
 * @param {...*} message
 */
export const logDebug = function (message) {
    if (pluginConfig.debug) {
        console.log('VueGtm :', ...arguments)
    }
}

/**
 * Load GTM script tag
 * @param {String}  id  GTM ID
 * @param {Object}  params query params object
 */
export const loadScript = function (id, params) {
    // eslint-disable-next-line one-var
    const win = window,
        doc = document,
        script = doc.createElement('script'),
        dl = 'dataLayer'

    win[dl] = win[dl] || []

    win[dl].push({
        event: 'gtm.js',
        'gtm.start': new Date().getTime(),
    })

    if (!id) {
        return
    }

    script.async = true
    const queryString = new URLSearchParams({
        id,
        ...(params || {}),
    })
    script.src = `https://www.googletagmanager.com/gtm.js?${queryString}`
    doc.body.appendChild(script)
}

/**
 * Check if GTM script is in the document
 * @return {boolean}
 */
export const hasScript = function () {
    return Array.from(document.getElementsByTagName('script')).some((script) => script.src.includes('googletagmanager'))
}

/**
 * Read CID from cookie
 *
 * @param name
 * @returns {null|*}
 */
export const getCidFromCookie = function (name = '_ga') {
    const value = Cookie.get(name)

    if (!value) return null;

    const valueParts = value.split('.')
    valueParts.shift()
    valueParts.shift()
    return valueParts.join('.')
}



// WEBPACK FOOTER //
// ./src/plugins/vue-gtm/utils.js